import type React from "react";
import { Input } from "@/components/ui/input";

interface InputWithIconProps extends React.InputHTMLAttributes<HTMLInputElement> {
    icon: Icon;
    label: string;
}

export const InputWithIcon: React.FC<InputWithIconProps> = ({ icon: IconComponent, label, className, ...props }) => {
    return (
        <div className="relative">
            <label htmlFor={props.id} className="sr-only">
                {label}
            </label>
            <IconComponent className="absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-500" />
            <Input className={`pl-10 ${className}`} {...props} />
        </div>
    );
};
